import { FC } from 'react'
import styled from 'styled-components'

const Container = styled.div`
    padding: 2rem 0;
    color: ${({ theme }) => theme.colors?.tfwBlackOpacity50 || '#666'};
    font-style: italic;
    width: 100%;
    text-align: center;
`

const ListingErrorCard: FC = () => {
    return <Container>Error loading listings.</Container>
}

export default ListingErrorCard
